import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';

import { FormatDatasetV2 } from 'app/model/dataset/dataset.v2';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.orc.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.ModelName_OrcDataset),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.ModelName_OrcDataset)
    ]
})
export class OrcDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;
    public static readonly COMPRESSION_CODEC?: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_CODEC',
        accepts:['String'],
        display: stringResources.ModelName_CompressionCodec
    })
    public compressionCodec?: string;

    public enablePhysicalSchema?: boolean = true;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
